import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/shared/ui/button";

interface ScrollButtonsProps {
  canScrollLeft: boolean;
  canScrollRight: boolean;
  isLoading: boolean;
  onScrollLeft: () => void;
  onScrollRight: () => void;
}

export function ScrollButtons({
  canScrollLeft,
  canScrollRight,
  isLoading,
  onScrollLeft,
  onScrollRight,
}: ScrollButtonsProps) {
  if (isLoading) return null;

  return (
    <>
      {canScrollLeft && (
        <Button
          variant="outline"
          size="icon"
          className="absolute left-2 top-1/2 -translate-y-1/2 z-20 h-8 w-8 bg-white shadow-md hover:bg-grid-50"
          onClick={onScrollLeft}
          aria-label="Scroll left"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
      )}

      {canScrollRight && (
        <Button
          variant="outline"
          size="icon"
          className="absolute right-2 top-1/2 -translate-y-1/2 z-20 h-8 w-8 bg-white shadow-md hover:bg-grid-50"
          onClick={onScrollRight}
          aria-label="Scroll right"
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      )}
    </>
  );
}
